import React from 'react';
import './CookieBanner.css';
import {useNavigate} from 'react-router-dom';
import {t} from 'i18next';
import {UaButton} from 'uppsala.ui.react';

const CookieBanner = () => {
  const navigate = useNavigate();
  const [showCookieBannerVisible, setCookieBannerVisible] = React.useState<boolean>(true);

  React.useEffect(() => {
    const cookies = document.cookie.split(';');
    const cookie = cookies.find((c) => c.trim().startsWith('Cookies_BorgerligVigsel'));
    if (cookie) {
      setCookieBannerVisible(false);
    }
  }, []);

  const handleCookieAccept = () => {
    const expirationDate = new Date();
    expirationDate.setFullYear(expirationDate.getFullYear() + 1);
    const cookieString = `Cookies_BorgerligVigsel=true; expires=${expirationDate.toUTCString()};`;
    document.cookie = cookieString;
    setCookieBannerVisible(false);
  };

  if (!showCookieBannerVisible) return <></>;

  return (
    <div className="cookie-banner-container">
      <div className="cookie-banner-content">
        <h2>{t('cookieBanner.title')}</h2>
        <p style={{margin: '14px 0px'}}>{t('cookieBanner.infoText')}</p>
        <p>{t('cookieBanner.ifNotAcceptedText')}</p>
        <div className="cookie-banner-button-row">
          <UaButton title={t('cookieBanner.allow')} style={{marginRight: '5px'}} onClick={handleCookieAccept} />
          <UaButton title={t('cookieBanner.allowNot')} onClick={() => navigate(-1)} />
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
